export const environment = {
  production: false,
  apiUrl: "https://api.internal.dev.ab-inbev.com/",
  baseUrlV2: "https://api.internal.dev.ab-inbev.com/pho-projects/api/v2",
  baseUrlV3: "https://api.internal.dev.ab-inbev.com/pho-projects/api/v3",
  baseUrl: "https://api.internal.dev.ab-inbev.com/pho-projects/api/",
  expurl: "https://api.internal.dev.ab-inbev.com/pho-go-process/",
  userUrl: "https://api.internal.dev.ab-inbev.com/pho-user/api/v1/",
  userUrlV3: "https://api.internal.dev.ab-inbev.com/pho-user/api/v3/",
  phoBaseUrl: "https://api.internal.dev.ab-inbev.com/pho/api/v1",
  phoBaseUrlV2: "https://api.internal.dev.ab-inbev.com/pho/api/v2",
  phoBaseUrlV3: "https://api.internal.dev.ab-inbev.com/pho/api/v3",
  goProcess: `https://api.internal.dev.ab-inbev.com/pho-go-process/tasks/`,
  goProcessStates: `https://api.internal.dev.ab-inbev.com/pho-go-process/refs/`,
};
